import Micromodal from 'micromodal'
import { getAjax } from '../util'

const MapPopup = (() => {
  const manager = {
    buttons: [],
    popupContent: document.querySelector('.js-map-popup-content'),
    isBinded: false,

    /**
     * Generates popup content
     * @param {Object} data Parsed JSON response
     */
    renderContent: function (data) {
      const lang = document.querySelector('html').getAttribute('lang')
      if (lang === 'it') {
        var infoContact = 'Sei un atleta/appassionato di allenamento/palestra e vuoi metterti in contatto col WTA Trainer per usufruire dei suoi servizi professionali? Inviaci richiesta a <a href="mailto:wtafunctionaltraining@gmail.com"><b>wtafunctionaltraining@gmail.com</b></a> e ti metteremo in contatto con lui!'
      } else if (lang === 'es') {
        var infoContact = 'Are you an athlete/training lover/gym and would like to get in touch with the WTA Trainer to have his professional services? Send us your request by email <a href="mailto:wtafunctionaltraining@gmail.com"><b>wtafunctionaltraining@gmail.com</b></a> and we will put you in touch with him!'
      } else {
        var infoContact = 'Are you an athlete/training lover/gym and would like to get in touch with the WTA Trainer to have his professional services? Send us your request by email <a href="mailto:wtafunctionaltraining@gmail.com"><b>wtafunctionaltraining@gmail.com</b></a> and we will put you in touch with him!'
      }
      const {
        image,
        name,
        address,
        city,
        region,
        country,
        phone,
        email,
        website,
        description
      } = data
      this.popupContent.innerHTML = `
      <div class="c-map-popup__container">
        <div class="c-map-popup__header">
          <div class="c-map-popup__image">
            <div class="image" style="background-image: url('${image ? image : '/images/user-default.png'}')"></div>
            ${lang === 'it' ? `<div class="info">Sei <b>${name}</b>?<br>Per cambiare la tua immagine profilo trainer devi <b>registrarti alla piattaforma</b>, <b>accedere alla tua dashboard</b> e <b>seguire le indicazioni</b> di aggiornamento immagine profilo.</div>` : ''}
          </div>
          <div class="c-map-popup__info">
            ${name ? (
              `<div class="c-map-popup__name">${name}</div>`
            ) : ''}
            ${address || city || region || country ? (
              `<div class="c-map-popup__info-block">
                ${address && city ? (
                  `<div>${address}, ${city}</div>`
                ) : city ? (
                  `<div>${city}</div>`
                ) : address ? (
                  `<div>${address}</div>`
                ) : ''}
                ${region && country ? (
                  `<div>${region}, ${country}</div>`
                ) : country ? (
                  `<div>${country}</div>`
                ) : region ? (
                  `<div>${region}</div>`
                ) : ''}
              </div>`
            ) : ''}
            ${phone || email || website ? (
              `<div class="c-map-popup__info-block">
                ${phone ? (
                  `<div><strong>Tel:</strong> ${phone}</div>`
                ) : ''}
                ${email ? (
                  `<div><strong>Email:</strong> ${email}</div>`
                ) : ''}
                ${website ? (
                  `<div><strong>Website:</strong> ${website}</div>`
                ) : ''}
              </div>`
            ) : ''}
            ${description ? (
              `<div class="c-map-popup__info-block">
              <b>${document.getElementById('translationCertifications').getAttribute('data-value')}</b><br>
              ${description.replace(/\r?\n/g, '<br />')}
              </div>`
            ) : ''}
            <div class="info">
              ${infoContact}
            </div>
          </div>
        </div>
        ${false ? (
          `<div class="c-map-popup__description">${description}</div>`
        ) : ''}
      </div>`
    },

    /**
     * Send request to retrieve map popup content
     * @param {String} dataRequest button data-request value
     */
    requestData: function (dataRequest) {
      const i = dataRequest.indexOf(' ')
      const model = dataRequest.substring(0, i)
      const uuid = dataRequest.substring(i+1)

      switch (model) {
        case 'trainer':
        case 'coach':
          getAjax(`/map_get_data/?model=trainer&uuid=${uuid}`, (res) => {
            const json = JSON.parse(res)
            console.log('TCL: MapPopup -> json', json)
            this.renderContent(json)
            Micromodal.show('mapPopup')
          })
          break
        case 'gym':
        case 'rehab':
          getAjax(`/map_get_data/?model=place&uuid=${uuid}`, (res) => {
            const json = JSON.parse(res)
            console.log('TCL: MapPopup -> json', json)
            this.renderContent(json)
            Micromodal.show('mapPopup')
          })
          break
        default:
          break
      }
    },

    init: function () {
      if (!this.isBinded) {
        this.renderContent = this.renderContent.bind(this)
        this.requestData = this.requestData.bind(this)
        window.requestMapPopupData = this.requestData
        this.isBinded = true
      }
      this.buttons = document.querySelectorAll('.js-map-popup-open')

      if (this.buttons.length) {
        this.buttons.forEach(el => {
          el.addEventListener('click', () => {
            const data = el.getAttribute('data-request')
            this.requestData(data, () => {
              Micromodal.show('mapPopup')
            })
          })
        })
      }
    }
  }

  const init = () => {
    manager.init()
  }

  return {
    init
  }
})()

export default MapPopup


// WEBPACK FOOTER //
// app/javascript/scripts/components/MapPopup.js